module.exports = __webpack_public_path__ + "0ad3c0960d5be647f0673e1a161b46b7.png";